/* @flow */

import type { KeyValuePair } from '../jsHelpers/types';

const isFirebaseConfigValid = (config: KeyValuePair<string>): boolean => config && typeof config === 'object' && typeof config.apiKey === 'string' && typeof config.projectId === 'string';

export { isFirebaseConfigValid };
